<script setup lang="ts">
import type { ChampionshipRegistrationTeam } from "@/model/championship/championship-registration-team"
import { useChampionshipRegistrationSelectTeamData } from "@/pages/Tasks/Tasks/championship-registration"
import { useRegistrationPolicy } from "@/pages/Tasks/Tasks/useRegistrationPolicy"
import { injectMandatory, useToggleableValue } from "@/vf"
import { computed } from "vue"
import { TaskViewMode } from "../../Issue/util"
import ChampionshipRegistrationCancelTeamRequestContent from "./ChampionshipRegistrationCancelTeamRequestContent.vue"

const props = defineProps<{
    registrationId: string
    team: ChampionshipRegistrationTeam
}>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const viewMode = injectMandatory(TaskViewMode, "Missing mandatory injection: TaskViewMode")
const data = useChampionshipRegistrationSelectTeamData()
const policy = useRegistrationPolicy(
    computed(() => data.value?.permissions),
    computed(() => viewMode),
)
const [opened, setOpened] = useToggleableValue<boolean>(false)

function open() {
    if (!policy.value.CancelTeamRequest || props.team.approvalState === "canceled") {
        return
    }

    setOpened(true)
}
</script>

<template>
    <div>
        <button
            type="button"
            class="wizard-button font-weight-normal"
            :class="{ dark: opened }"
            :disabled="!policy.CancelTeamRequest || team.approvalState === 'canceled'"
            @click="open"
        >
            <b>{{ $t("@tasks:tasks.championship_registration.edit_team_wizard.cancel_team") }}</b>
            <span v-if="team.approvalState === 'canceled'">
                {{ $t("@tasks:tasks.championship_registration.edit_team_wizard.team_already_canceled") }}
            </span>
            <span v-else>
                {{ $t("@tasks:tasks.championship_registration.edit_team_wizard.cancel_team_description") }}
            </span>
        </button>

        <div v-if="opened" class="px-2">
            <ChampionshipRegistrationCancelTeamRequestContent
                :registration-id="registrationId"
                :team="team"
                @updated="emit('updated')"
            />
        </div>
    </div>
</template>
